module.exports = __webpack_public_path__ + "media/images/home/edueeno-blue-4ea8125f2a9f62b7d3c032d53868c194.svg";